export const PLUGIN_MOCK_CONFIG = {
  USE_MOCK: process.env.REACT_APP_PLUGIN_USE_MOCK,
};
